import React, { useMemo } from 'react';
import {
  useRegionCurrency,
  useProductService,
  useReviewService,
  ProductStockStatus,
  createReviewStatsMap,
  getPriceProductBasicInfo,
  ProductType,
} from '@skin-seoul/service';
import { GridItem } from '@skin-seoul/design-system';
import SkinSeoulHiddenGems from './components/SkinSeoulHiddenGems';
import { VerticalProductCard } from '../../components/ProductCard';

const HiddenGemProductList = () => {
  const { useGetProductsCollections } = useProductService();
  const { useGetReviewStatistics } = useReviewService();
  const { currency } = useRegionCurrency();

  const { data } = useGetProductsCollections({
    collectionName: 'GGU Hidden Gems',
    limit: 50,
    stockStatus: ProductStockStatus.instock,
    currency: currency,
  });

  const products = useMemo(() => {
    return (data?.products?.length ? data.products : []).slice(0, 5);
  }, [data]);

  const { data: reviewStats } = useGetReviewStatistics({
    productIds: products.map((product) => product.productId).join(','),
  });

  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats), [reviewStats]);

  return (
    <React.Fragment>
      {products.map((product) => {
        const lowestPriceProductInfo = getPriceProductBasicInfo(product);
        const productReviewStats = reviewStatsMap[product.productId];

        return (
          <GridItem key={product.productId + 'hidden-gem-product-list'} minWidth={0}>
            <VerticalProductCard
              href={product.productLink}
              productType={ProductType.Variable}
              name={product.name}
              brand={product.brand}
              productImage={product.productImageUrls[0] || ''}
              sku={product.sku}
              currency={product.currency}
              originalPrice={lowestPriceProductInfo.originalPrice}
              salePrice={lowestPriceProductInfo.salePrice}
              rating={productReviewStats?.averageRate}
              reviewCount={productReviewStats?.totalReviews}
              onClick={() => (window.location.href = product.productLink)}
              theme="light"
            >
              <VerticalProductCard.Image bottomSlot={<SkinSeoulHiddenGems />} />
              <VerticalProductCard.Content>
                <VerticalProductCard.InfoName />
                <VerticalProductCard.InfoRating />
                <VerticalProductCard.InfoPrice />
              </VerticalProductCard.Content>
            </VerticalProductCard>
          </GridItem>
        );
      })}
    </React.Fragment>
  );
};

export default HiddenGemProductList;
